import { render, staticRenderFns } from "./BoxView.vue?vue&type=template&id=5d25aff8&scoped=true&"
import script from "./BoxView.vue?vue&type=script&lang=js&"
export * from "./BoxView.vue?vue&type=script&lang=js&"
import style0 from "./BoxView.vue?vue&type=style&index=0&id=5d25aff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25aff8",
  null
  
)

export default component.exports